(function () {
	'use strict';
	var buttons = document.querySelectorAll('.faq-item__question');
	var categoryLinks = document.querySelectorAll('.faq-categories a');

	function setActiveCategory(link) {
		categoryLinks.forEach(function (categoryLink) {
			var active = categoryLink === link;
			categoryLink.classList.toggle('is-active', active);
			if (active) categoryLink.setAttribute('aria-current', 'location');
			else categoryLink.removeAttribute('aria-current');
		});
	}

	categoryLinks.forEach(function (link) {
		link.addEventListener('click', function () {
			setActiveCategory(link);
		});
		if (link.hash && link.hash === window.location.hash) setActiveCategory(link);
	});

	window.addEventListener('hashchange', function () {
		categoryLinks.forEach(function (link) {
			if (link.hash === window.location.hash) setActiveCategory(link);
		});
	});

	buttons.forEach(function (button) {
		button.addEventListener('click', function () {
			var panel = document.getElementById(button.getAttribute('aria-controls'));
			var opening = button.getAttribute('aria-expanded') !== 'true';
			button.setAttribute('aria-expanded', opening ? 'true' : 'false');
			panel.hidden = !opening;
		});
	});
}());
